// Helpers shared by the lab and doctor views of test-result files.

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];

// What the backend's upload filter actually accepts.
export const ATTACHMENT_ACCEPT = '.jpg,.jpeg,.png,.pdf,.doc,.docx';

// Files uploaded to S3 carry a mime type in `fileType`; older rows only have a
// file name, so fall back to the extension.
export const isImageAttachment = (file) => {
    if (!file) return false;
    if (typeof file.fileType === 'string' && file.fileType.startsWith('image/')) return true;
    const name = (file.fileName || file.fileUrl || '').toLowerCase();
    return IMAGE_EXTENSIONS.some((ext) => name.endsWith(ext));
};

// A lab result may be a typed value, an attached document, or both.
export const attachmentsOf = (record) =>
    (record?.attachments || record?.attachmentUrl || []).filter((file) => file && file.fileUrl);

// Lab results mirrored into a visit keep their files in `attachments`; rows
// written before that only kept a single URL in `attachment`.
export const labTestFiles = (labTest) => {
    const files = attachmentsOf(labTest);
    if (files.length > 0) return files;
    return labTest?.attachment
        ? [{ fileUrl: labTest.attachment, fileName: labTest.testName }]
        : [];
};
